import { assertFetchGetInfrastructureGeoObjectsResponse } from './asserts';
import { prepareInfrastructureItems } from '../../../Map/mappers/infrastructure';
import {
  fetchGetInfrastructureGeoObjects,
  IGetInfrastructureGeoObjectsRequest,
  TGetInfrastructureGeoObjectsResponse,
} from '../../repositories/infrastructure-caching/v1/get-infrastructure-geo-objects';
import { IApplicationContext } from '../../types/applicationContext';
import { IInfrastructurePointItem } from '../../types/infrastructure';

export async function fetchInfrastructureFeatures(
  parameters: IGetInfrastructureGeoObjectsRequest,
  { httpApi, logger, config, cancellationTokenManager }: IApplicationContext,
): Promise<IInfrastructurePointItem[]> {
  const cancelPreviousRequest: boolean =
    config.get<boolean>('mapSearchFrontend.fetchInfrastructureFeatures.cancelPreviousRequest') ?? false;

  let abortSignal: AbortSignal | undefined;
  if (cancelPreviousRequest && cancellationTokenManager) {
    abortSignal = cancellationTokenManager.getSignalAndCancelPrevious('fetchAdditionalFeatures');
  }

  try {
    const res: TGetInfrastructureGeoObjectsResponse = await fetchGetInfrastructureGeoObjects({
      httpApi,
      parameters,
      config: {
        signal: abortSignal,
      },
    });

    assertFetchGetInfrastructureGeoObjectsResponse(res);

    return prepareInfrastructureItems(res);
  } catch (e) {
    logger.warning(e, {
      domain: 'fetchInfrastructureFeatures',
      degradation: 'Гео-объекты дополнительных слоев',
    });

    return [];
  }
}
